import type Web3 from 'web3';

export type Web3Constructor = typeof Web3;

let loading: Promise<Web3Constructor> | undefined;

/**
 * Loads the `web3` library on first use, and resolves to its constructor.
 *
 * WHY: web3 and its sub-packages are ~330 KiB raw, and the /primary, /nft and
 * /hat layouts create the wallet context on every page. Imported statically,
 * it was in each of those pages' preloaded scripts, although only connecting a
 * wallet, signing or calling a contract needs it. The import is shared by
 * concurrent callers.
 */
export const loadWeb3 = (): Promise<Web3Constructor> => {
	if (!loading) {
		loading = import('web3').then((module) => module.default);

		// A failed chunk load (flaky network, a deploy mid-session) must not be
		// cached, or every later wallet connection would fail without retrying.
		loading.catch(() => {
			loading = undefined;
		});
	}

	return loading;
};
